"use client";

import { useEffect, useState } from "react";
import { createClient } from "@/utils/supabase/client";

export function usePartyFollowersCount(
  userId: string | null | undefined,
  enabled: boolean,
): number | null {
  const [followersCount, setFollowersCount] = useState<number | null>(null);

  useEffect(() => {
    if (!enabled || !userId) {
      setFollowersCount(null);
      return;
    }

    let cancelled = false;
    void (async () => {
      const supabase = createClient();
      const { data, error } = await supabase
        .from("profiles")
        .select("followers_count")
        .eq("id", userId)
        .maybeSingle();

      if (cancelled || error) return;

      const count = (data as { followers_count?: number | null } | null)?.followers_count;
      setFollowersCount(typeof count === "number" && Number.isFinite(count) ? count : null);
    })();

    return () => {
      cancelled = true;
    };
  }, [enabled, userId]);

  return followersCount;
}
